import Vue from 'vue';
import { Getter, namespace, Action } from 'vuex-class';
import { storeModules } from '../../../../store';
import reportNotificationTypesStore from "../../../../store/report/report-notification/define-types.store";
import { NotificationModel } from '../../../../models/report';
import { uniqBy } from 'lodash';
import { GenericBaseParameter } from '../../../../models/base-parameter';
import { IUserListingModel } from '../../../../models/user/user-listing.model';
import UserTypes from "../../../../store/user/user-types.store";
import { UserParameterModel } from '../../../../models/user/index';

const ReportGetter = namespace(storeModules.ReportNotification, Getter);
const UserAction = namespace(storeModules.User, Action);

export class NotificationViewModel extends Vue {

  @UserAction(UserTypes.Get.LIST_OF_USERS_BY_IDNAME)
  storeGetListOfUsers: (
    searchParam: GenericBaseParameter<UserParameterModel>
  ) => Promise<IUserListingModel[]>;

  dtUserSearchParam: GenericBaseParameter<UserParameterModel> = new GenericBaseParameter<UserParameterModel>();
  totalUnread: number = 0;

  /**  */
  @ReportGetter(reportNotificationTypesStore.Get.GET_NOTIFICATIONS)
  notification: NotificationModel[];

  /** */
  get coListOfNotifications(): NotificationModel[] {
    return this.notification || [];
  }

  get coListOfNotificationsGroup(): any[] {
    let groups = uniqBy(this.notification, (c) => (c.DateTime as any).toLongDate())
    return groups || [];
  }

  get coTotalNotification() {
    return (Number(this.coListOfNotifications.length) + Number(this.totalUnread));
  }

  getListOfNotifications(group: any) {
    let items = this.notification.filter(c => (c.DateTime as any).toLongDate() == group)
    return items || [];
  }
}